// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"406f1a15","997":"3535e5de"}[chunkId] + ".chunk.css";
};